function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavMenu from './NavMenu';
import utils from '@/js/utils';
import { mapState } from 'vuex';
import { ROLES_LIST, GA_EVENTS } from '@/js/constants';
import { assertUnaryExpression } from 'babel-types';
import HubIaMigrationDialog, { HUB_IA_MENU_KEY } from '@/apps/chatbots/components/HubIaMigrationDialog';
export default {
  components: {
    NavMenu: NavMenu,
    HubIaMigrationDialog: HubIaMigrationDialog
  },
  data: function data() {
    return {
      options: [],
      selectionMenu: null,
      key_menu: 1,
      menu_aux: []
    };
  },
  props: {
    menu: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isMini: {
      type: Boolean,
      default: false
    },
    isPageHome: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['isTableauActive', 'isPowerBIActive', 'isDataStudioActive'])), mapState('data-platform', ['companyCode', 'companyName'])), mapState('app', ['menuSelected'])), {}, {
    onFilterMenu: function onFilterMenu() {
      var _this = this;
      var _menu = this.menu.filter(function (me) {
        return (me.roles.filter(function (rol) {
          return window.userInfo.userRoles.includes(rol);
        }).length > 0 || me.sinRoles == true) && _this.checkFlags(me);
      });
      _menu.forEach(function (x) {
        x.name_i18n = _this.traductor(x.key);
      });
      return _menu;
    }
  }),
  watch: {
    menuSelected: function menuSelected(to, from) {
      console.log("change route", to, from);
      this.changeRoute();
    },
    '$route.path': function $routePath() {
      this.changeRoute();
    }
  },
  created: function created() {
    var _this2 = this;
    console.log("⁉️⁉️⁉️⁉️⁉️⁉️menuSelected: ", this.menuSelected);
    //console.log(this.$router.history.current.path)
    this.buscarMenuActual(this.$router.history.current.path);
    this.menu_aux = this.menu.filter(function (me) {
      return (me.roles.filter(function (rol) {
        return window.userInfo.userRoles.includes(rol);
      }).length > 0 || me.sinRoles == true) && _this2.checkFlags(me);
    });
    this.menu_aux.forEach(function (x) {
      x.name_i18n = _this2.traductor(x.key);
    });
    //console.log("dbug", this.menu_aux)
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getSelectedMenu: function getSelectedMenu() {
      var _this3 = this;
      return this.selectionMenu ? this.menu.find(function (x) {
        return x.key == _this3.selectionMenu;
      }) : {};
    },
    changeRoute: function changeRoute() {
      //this.buscarMenuActual(this.$router.history.current.path)
      //console.log(this.menuSelected)
      if (this.menuSelected) {
        this.selectMenu(this.menuSelected);
      } else {
        this.selectMenu(this.onFilterMenu[0].key);
      }
    },
    buscarMenuActual: function buscarMenuActual(path) {
      var _this4 = this;
      var encontrado = false;
      this.onFilterMenu.forEach(function (me) {
        me.items.forEach(function (nivel1) {
          if (nivel1.link == path) {
            // encontrado
            _this4.selectMenu(me.key);
            encontrado = true;
          }
          if (nivel1.subItems) {
            nivel1.subItems.forEach(function (nivel2) {
              if (nivel2.link == path) {
                ////console.log("encontrado: ", nivel1)
                _this4.selectMenu(me.key);
                encontrado = true;
              }
            });
          }
        });
      });
      if (!encontrado) {
        //console.log(this.menuSelected)
        if (this.menuSelected) {
          if (path == "/Home") {
            this.selectMenu("menu.home_page");
          } else {
            this.selectMenu(this.menuSelected);
          }
        } else {
          this.selectMenu(this.onFilterMenu[0].key);
        }
      }
    },
    selectMenu: function selectMenu(value) {
      this.selectionMenu = value;
    },
    requireRole: function requireRole(item) {
      var rolesRequired = item.roles || [];
      var userRoles = window.userInfo.userRoles || [];
      // if both are empty allow pass
      if (rolesRequired.length === 0) {
        return true;
      } else {
        // compare arrays
        var roleFound = utils.findArrayInArray(rolesRequired, userRoles);
        return !!roleFound.length;
      }
    },
    checkFlags: function checkFlags(sub1) {
      //console.log("test:",sub1)
      if (sub1.intercorpAdminOnly) {
        var _userInfo = window.userInfo || {};
        var roles = _userInfo.userRoles || [];
        var code = this.companyCode === null || this.companyCode === undefined ? '' : String(this.companyCode).trim();
        var isInterbankProfile = !!code && code.padStart(3, '0') === '000' || String(this.companyName || '').toLowerCase() === 'interbank';
        var isIntercorpProfile = !!code && code.padStart(3, '0') === '032';
        var hasAdminAccess = roles.includes('attribute_admin') && (isIntercorpProfile || isInterbankProfile);
        var hasUserAccess = roles.includes('attribute_user') && isInterbankProfile;
        if (!hasAdminAccess && !hasUserAccess) {
          return false;
        }
      }
      if (sub1.check_flag) {
        var split = sub1.check_flag.split('/');
        if (split.length > 1) if (!this.$store.state[split[0]][split[1]]) return false;
      }
      if (sub1.checkTableau) {
        if (!this.isTableauActive) return false;
        return true;
      } else if (sub1.checkBI) {
        if (!this.isPowerBIActive) return false;
        return true;
      } else if (sub1.checkDataStudio) {
        if (!this.isDataStudioActive) return false;
        return true;
      } else if (sub1.checkDomain) {
        if (window.userInfo.domain != 'intercorp.com.pe') {
          return false;
        }
        return true;
      } else {
        return true;
      }
    },
    // Hub IA convive en dos versiones: se elige en el modal antes de entrar.
    onHubIaSelect: function onHubIaSelect(version) {
      if (version == 'v1') {
        this.key_menu += 1;
      } else {
        // V2 abre otra pestaña: esta se queda donde estaba.
        this.restoreMenuSelection();
      }
    },
    restoreMenuSelection: function restoreMenuSelection() {
      this.selectionMenu = this.menuSelected;
    },
    onChangeMenu: function onChangeMenu(item) {
      //console.log("onchangemenu",item)
      if (item.key == HUB_IA_MENU_KEY) {
        this.$refs.hub_ia_dialog.onOpen();
        return;
      }
      if (item.key == 'menu.home_page') {
        this.$router.push({
          name: "HomePage"
        });
      }
      this.$store.commit("app/setMenuSelected", item.key);
      this.selectionMenu = item.key;
      this.key_menu += 1;
    },
    onChangeMenuSelect: function onChangeMenuSelect(key) {
      //console.log(this.selectionMenu)
      //console.log("dbug_home: ",typeof key)
      if (key == HUB_IA_MENU_KEY) {
        this.$refs.hub_ia_dialog.onOpen();
        return;
      }
      if (key == 'menu.home_page') {
        this.$router.push({
          name: "HomePage"
        });
      }
      this.key_menu += 1;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.SELECT_ITEM,
          element_name: this.getmenu(this.selectionMenu),
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email)
        });
      }
      this.$store.commit('app/setMenuSelected', this.selectionMenu);
    }
  }
};